import { useState } from 'react';

import { useDarkMode } from 'utils/hooks/DarkMode';
import ExpandIcon from 'assets/icons/left-panel-open.svg';
import CollapseIcon from 'assets/icons/left-panel-close.svg';
import ExpandWhiteIcon from 'assets/icons/left-panel-open-white.svg';
import CollapseWhiteIcon from 'assets/icons/left-panel-close-white.svg';
import { HorizontalAccordionProps } from 'interfaces/components/HorizontalAccordion';

const HorizontalAccordion = ({
  tabs,
  title,
  footer,
  content,
  onChange,
  className
}: HorizontalAccordionProps) => {
  const [expanded, setExpanded] = useState(true);
  const isDarkMode = useDarkMode('(prefers-color-scheme: dark)');

  const toggleExpanded = () => {
    setExpanded(prev => !prev);

    if (onChange) {
      onChange();
    }
  };

  const getIcon = () => {
    if (isDarkMode) {
      return expanded ? CollapseWhiteIcon : ExpandWhiteIcon;
    }

    return expanded ? CollapseIcon : ExpandIcon;
  };

  return (
    <div
      className={`flex flex-col items-center bg-white
                  dark:bg-black duration-300 ease-linear
                  rounded-lg border border-gray-300 dark:border-850 overflow-hidden ${className}
                  ${expanded ? 'w-full max-w-[267px]' : 'w-12 max-w-12'}`}
    >
      <div className='flex flex-row-reverse items-center justify-between gap-4 w-full min-w-12 p-3'>
        <img
          src={getIcon()}
          onClick={toggleExpanded}
          alt={expanded ? 'collapse' : 'expand'}
          className={`min-w-5 min-h-5 cursor-pointer ${
            expanded ? '' : '-ml-4'
          }`}
        />

        {title ? (
          <p
            className={`font-semibold text-base text-black dark:text-white select-none ease-linear duration-200
            ${expanded ? 'max-w-96 opacity-100' : 'max-w-0 opacity-0'}`}
          >
            {title}
          </p>
        ) : (
          <div
            className={`duration-200 ease-linear overflow-hidden ${
              expanded ? 'max-w-96 opacity-100' : 'max-w-0 h-0 opacity-0'
            }`}
          >
            {tabs}
          </div>
        )}
      </div>

      <div
        className={`w-full ease-linear duration-300
          ${expanded ? 'max-h-[1200px] opacity-100' : 'max-h-0 opacity-0'}`}
      >
        <hr />

        <div className='flex flex-col p-4'>{content}</div>
        {footer ? (
          <>
            <hr />

            <div className='px-4 py-3'>{footer}</div>
          </>
        ) : undefined}
      </div>
    </div>
  );
};

export default HorizontalAccordion;
